import LoginBody from "@/components/landing/auth/LoginTwoBody";

export default function LoginTwoPage() {
  return <LoginBody />;
}
